module.exports = __webpack_public_path__ + "img/product-placeholder-67.de2a6d6.png";